import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageMeta from '../components/PageMeta';
import Reveal from '../components/Reveal';
import ComparisonTable from '../components/ComparisonTable';
import { FinalCTA, PageHero, SectionHeading } from '../components/SharedSections';

const { FiClipboard, FiFilter, FiColumns, FiSettings, FiArrowRight } = FiIcons;

function Compare() {
  const steps = [[FiClipboard, 'Assess', 'Document users, workflows, integrations, constraints, and goals.'], [FiFilter, 'Shortlist', 'Remove poor-fit platforms before demonstrations consume your time.'], [FiColumns, 'Compare', 'Evaluate pricing, administration, support, AI, and implementation side by side.'], [FiSettings, 'Implement', 'Coordinate porting, onboarding, training, and accountability after launch.']];

  return (
    <>
      <PageMeta title="Compare UCaaS Providers" description="Compare RingCentral, Zoom, GoTo, Vonage, 8x8, and Dialpad with vendor-neutral guidance." />
      <PageHero eyebrow="Provider comparison" title="Compare the market without becoming a telecom expert." text="Use the grid to start your research. Then let Cambia validate the details that determine whether a platform succeeds in your environment." />
      <section className="section">
        <Reveal><SectionHeading eyebrow="Side-by-side view" title="Leading UCaaS providers at a glance." text="Feature availability can vary by plan, geography, and release. Cambia verifies current requirements during your assessment." /></Reveal>
        <Reveal><ComparisonTable /></Reveal>
        <p className="table-note">This editable comparison is informational, not a guarantee of current plan-level availability.</p>
        <Reveal className="matrix-callout">
          <div>
            <span className="eyebrow">Need a deeper view?</span>
            <h3>Want to filter by compliance, AI depth, or CRM integrations?</h3>
            <p>Explore the full interactive Provider &amp; Supplier Matrix.</p>
          </div>
          <Link className="button button-secondary" to="/provider-matrix">Explore the Provider Matrix <SafeIcon icon={FiArrowRight} /></Link>
        </Reveal>
      </section>
      <section className="section tint">
        <Reveal><SectionHeading eyebrow="Our recommendation process" title="A focused path from needs to implementation." center /></Reveal>
        <div className="card-grid four">
          {steps.map(([icon, title, text], index) => <Reveal className="process-card" key={title}><span>0{index + 1}</span><SafeIcon icon={icon} /><h3>{title}</h3><p>{text}</p></Reveal>)}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}

export default Compare;